<template>

    <section id="skillssection">
    
        <article id="skills">
                <div class="container-fluid skills">
                    <h1 class="section-header">{{ heading }}</h1>
                    <h2> {{ skillstext }}</h2>

                    <!-- start of filters  -->
                    <div class="row filters">
                        <ul class="list-inline mx-auto">
                        <li
                            v-for="item in filters"
                            :key="item.title"
                            class="list-inline-item filter"
                        >
                            <a
                            class="nav-item"
                            :class="item.filter === currentFilter ? 'active' : null"
                            :data-filter="item.filter"
                            @click="setFilter"
                            >{{ item.filter }}</a
                            >
                        </li>
                        </ul>
                    </div>
                
                    <!-- end of filters  -->
                

                    <!-- start of skill container  -->

                        <div id="skills-container" class="row skills-cont">

                        <div
                            data-aos="fade-down"
                            data-aos-duration="1000"
                            data-aos-anchor-placement="bottom-bottom"
                            v-for="(item, index) in filteredSkills"
                            :key="index"
                            class="col-sm-6 col-md-2 flex-col"
                        >

                            <div class="skills-item">
                            <img :src="require(`../assets/images/skills/${item.image}`)" />
                            <div class="overlay">
                                
                                <div class="skills-item-content">
                                    <h3>{{ item.title }}</h3>
                                </div>
                                
                            </div>
                            </div>
                        </div>
                        </div>
                            
                            
                    <!-- end of skill container  -->
                </div>
        </article>

    </section>

</template>

<script>

import data from "../data/data.json";

export default {
  name: "SkillsView",
  props: {},
  data() {
    return {
      skillList: data.skills.skillList,
      heading: data.main.headings.skills,
      currentFilter: data.skills.defaultFilter,
      skillstext: data.skills.skillstext
    };
  },
  computed: {
    filteredSkills() {
      var skillList = data.skills.skillList;
      var filter = this.currentFilter;
      var filtered = skillList.filter(function(x) {
        return x.filter === filter;
      });
      return filtered;
    },
    filters() {
      var filterList = [];
      var skillList = data.skills.skillList;
      filterList = skillList.filter(function(x) {
        if (!filterList.includes(x.filter)) {
          filterList.push(x.filter);
          return x.filter;
        }
      });
      return filterList;
    },
  },
  methods: {
    setFilter(event) {
      this.currentFilter = event.target.dataset.filter;
    },
  },
};
</script>